import {
  faCheckCircle,
  faClockRotateLeft,
  faCog
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React from "react";
import { STATUS_EXCUTED, STATUS_IN_PROGRESS } from "../../../../api/constant";
const StatusEntry = ({ status_id }) => {
  let text = "Sin iniciar";
  let color = "orange";
  let icon = faClockRotateLeft;
  if (status_id === STATUS_EXCUTED) {
    color = "green";
    text = "Finalizado";
    icon = faCheckCircle;
  } else if (status_id === STATUS_IN_PROGRESS) {
    color = "red";
    text = "En proceso";
    icon = faCog;
  }
  return (
    <span>
      <FontAwesomeIcon style={{ color: color }} icon={icon} />
      &nbsp;{text}
    </span>
  );
};

export default StatusEntry;
